import type { BariPreCloseProcessPrematurelyData } from '@common/validation/customControls/bariPre/bariPreCloseProcessPrematurely/v1/bariPreCloseProcessPrematurelySchemaV1';

export const initialData: BariPreCloseProcessPrematurelyData = {
    reden_besluit: null,
    sluit_proces: false,
};
